import { useId, useRef, useState, type ReactNode } from "react";
import { CircleHelp } from "lucide-react";

/** Kept inside the native dialog so help remains available in its top layer. */
export function MaintenanceHelp({ label, children }: { label: string; children: ReactNode }) {
  const id = useId();
  const [open, setOpen] = useState(false);
  const anchor = useRef<HTMLSpanElement>(null);
  const [position, setPosition] = useState({ left: 0, width: 240, above: false });
  const show = () => {
    const element = anchor.current;
    if (!element) return;
    const rect = element.getBoundingClientRect();
    const bounds = element.closest("dialog")?.getBoundingClientRect() ?? { left: 0, right: window.innerWidth, bottom: window.innerHeight, width: window.innerWidth };
    const width = Math.min(240, bounds.width - 32);
    setPosition({ left: Math.min(Math.max(rect.left, bounds.left + 16), bounds.right - width - 16) - rect.left,
      width, above: bounds.bottom - rect.bottom < 180 });
    setOpen(true);
  };
  return <span ref={anchor} className="relative inline-flex shrink-0 align-middle" onMouseEnter={show} onMouseLeave={() => setOpen(false)}>
    <button type="button" aria-label={`${label}の説明`} aria-expanded={open} aria-describedby={open ? id : undefined}
      className="inline-flex h-7 w-7 items-center justify-center rounded text-muted-foreground hover:text-foreground focus-visible:outline focus-visible:outline-2"
      onFocus={show} onBlur={() => setOpen(false)} onClick={show}
      onKeyDown={event => { if (event.key === "Escape" && open) { event.preventDefault(); event.stopPropagation(); setOpen(false); } }}>
      <CircleHelp className="h-4 w-4" aria-hidden="true" />
    </button>
    {open ? <span id={id} role="tooltip" style={{ left: position.left, width: position.width, ...(position.above ? { bottom: "100%" } : { top: "100%" }) }} className="absolute z-20 rounded border border-border bg-popover p-3 text-left text-sm font-normal text-popover-foreground shadow-lg">{children}</span> : null}
  </span>;
}
